// Newest first.
export const REVIEW_HIGHLIGHTS = [
  {
    id: "jeremy-h",
    name: "Jeremy H.",
    rating: 5,
    dateLabel: "10/15/2026",
    source: "Customer review",
    text: "The team was really friendly and were diligent getting my things into a third-floor apartment, which is never easy!",
  },
  {
    id: "josh-b",
    name: "Josh B.",
    rating: 5,
    dateLabel: "Sep 2026",
    source: "Google review",
    text: "Swift move and clean did a wonderful job, they were quick, fair, and honest. I hope to not have to move again anytime soon, but if I were to, I would definitely call these guys again. They even picked up the u haul truck for me, and drove it. The world needs more business like these. They went above and beyond and I truly felt like they cared about me as a customer.",
  },
  {
    id: "samaraweera-j",
    name: "Samaraweera J.",
    rating: 4,
    dateLabel: "07/30/2026",
    source: "Customer review",
    text: "The only downside was the additional charges for larger items, which were not mentioned earlier. However, the moving crew was working hard and provided excellent service, which exceeded the standard.",
  },
  {
    id: "kelly-f",
    name: "Kelly F.",
    rating: 5,
    dateLabel: "04/15/2026",
    source: "Customer review",
    text: "Swift and Clean showed up last minute and followed all instructions perfectly! I would use this service again in the future.",
  },
  {
    id: "dan-m",
    name: "Dan M.",
    rating: 5,
    dateLabel: "04/14/2026",
    source: "Customer review",
    text: "Very polite and professional. Two hard workers. They were a blessing with their help packing.",
  },
  {
    id: "social-work-confidential",
    name: "Social Work Confidential",
    rating: 5,
    dateLabel: "2 weeks ago",
    source: "Google review",
    text: "Swift and Clean showed up last minute about an hour after movers were requested through Moving Help. This is a great company that will show up and do the job the way you would like it done! A definite recommendation to use this service.",
  },
];
